import React, { useState, useEffect, useRef } from 'react';

import { Chart } from "react-google-charts";

import GoogleMapReact from 'google-map-react';

import GMap from './GMap';

// import { MapContainer, TileLayer, useMap } from 'react-leaflet'
// import { MapContainer } from 'react-leaflet/MapContainer'
// import { TileLayer } from 'react-leaflet/TileLayer'
// import { useMap } from 'react-leaflet/hooks'

import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';
//import { Helmet } from 'react-helmet';

import * as Hosts from '../../../Hosts';
import { reqGET, repo_img_link, /*set_language,*/ content_language, translate } from '../../../Utils';

import Loader from '../../../loader';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
//import Preview from '../Preview/Preview';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

import AssecImage from "../ASSEC_Image/Image"

import { language } from '../WEBContent/Language';

export default function Routes(props) {
    // const { pathname } = useLocation();

	const [, set_dados] = useState(null);
	const dados_chart = useRef([]);
	const dados_chart_2 = useRef([]);
	const dados_mapa_primary = useRef([]);
	const dados_mapa = useRef([]);
	const dados_mapa_settings = useRef({});

    const [isloading, setLoading] = useState(true);


    const GOOGLE_MAP_API_KEY = 'AIzaSyCZB3DS4HSEdzCRKvhscjp_QzW4o9buga4';

    const loadGoogleMapScript = (callback) => {
        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
          callback();
        } else {
          const googleMapScript = document.createElement("script");
          googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=geometry`;
          window.document.body.appendChild(googleMapScript);
          googleMapScript.addEventListener("load", callback);
        }
    }

    
    const [loadMap, setLoadMap] = useState(false);

    const data_interface = {
        id: '',
        info: {},
        content: {}
    }
    const [content, set_content] = useState(data_interface);

	const [lang, set_lang] = useState(localStorage.getItem('lang'))
	const [/*lang_id*/, set_lang_id] = useState('1')

    // const AnyReactComponent = ({ text }) => <div>{text}</div>;
    const AnyReactComponent = ({ icon }) => <div><i className={"bi bi-" + icon}></i></div>;

    const [axes_chart, ] = useState([
        { 
            primary: true, 
            type: 'linear', 
            position: 'bottom'
        },
        { 
            type: 'linear', 
            position: 'left'
        }
    ])

    useEffect(() => {
        
        loadGoogleMapScript(() => {
            setLoadMap(true)
        });
        
        try {
			let id = props.info.state.id;
			let slug = props.info.state.slug;
			//let preview_id = props.info.state.preview;

            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })

            if(id !== '') {

                let getInfoId = async () => {
                    await reqGET(`${Hosts.SIMCore_API}/platform/routes/${id}`)
                        .then(async res => { 
                            if(res.data.length > 0) {

                                //let status = 0
                                if(res.data[0].activo && res.data[0].visible) {
                                    //status = 1
                                    set_content(res.data[0]) 

                                    // console.log('data_chart[0].data', data_chart[0].data)
                                    // console.log('res.data[0].composicao[0].markers', res.data[0].composicao[0].markers)

                                    let chart_data = []
                                    let chart_data_2 = []
                                    chart_data_2[0] = ["km", "Altitude"]
                                    for await (let el of res.data[0].composicao[0].markers) {
                                        chart_data.push([el.distance, el.altitude])
                                        
                                        let aux = []
                                        aux.push(el.distance, el.altitude)
                                        chart_data_2.push(aux)
                                    }
                                    set_dados(dados_chart.current = [{
                                        label: 'Altitude',
                                        data: chart_data
                                    }])
                                    set_dados(dados_chart_2.current = chart_data_2)

                                    set_dados(dados_mapa_primary.current = res.data[0].composicao[0].markers)
                                    set_dados(dados_mapa.current = JSON.parse(JSON.stringify(res.data[0].composicao[0].markers)))

                                    set_dados(dados_mapa_settings.current = {
                                        center: {
                                            lat: res.data[0].composicao[0].markers[0].coordenadas.latitude,
                                            lng: res.data[0].composicao[0].markers[0].coordenadas.longitude
                                        },
                                        zoom: 14
                                    })

                                    setLoading(false) 
                                }
                                else {
                                    set_content(res.data[0]) 
            
                                    setLoading(false) 
                                }
                            }
                        })
                        .catch(erro => console.log('ERROR', erro))
                }
            
                let getInfoSlug = async () => {
                    reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/${slug}`)
                        .then(res => { 
                            if(res.data.length > 0) {
        
                                var hoje = new Date();
                                let status = 0
                                if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                                    var date_p = new Date(res.data[0].info.date.published);
        
                                    status = 1
                                    if(hoje >= date_p) 
                                        status = 2
                                }
        
                                if(status !== 2)  {
                                    res.data[0].content = [{text: 'rascunho ou agendado'}]
        
                                    set_content(res.data[0])
                                    setLoading(false)
                                }
                                else {        
                                    set_content(res.data[0]) 
        
                                    setLoading(false) 
                                }
                            }
                        })
                        .catch(erro => console.log('ERROR', erro))
                }

                if(id !== undefined && id !== 'undefined' && id !== '') {
                    getInfoId()
                }
                else if(slug !== undefined && slug !== 'undefined' && slug !== '')  {
                    getInfoSlug()
                }
            }
            else {
                console.log('=== ""')
            }

            return

        } catch {
            console.log('nada')

			return
		}
        
    }, [props.info.state.id, props.info.state.preview, props.info.state.slug]);



    const hover_chart = (el) => {


        console.log('el', el)

    }

    
    const chartEvents = [
        {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
                const chart = chartWrapper.getChart();
                google.visualization.events.addListener(chart, "onmouseover", e => {
                    const { row, /*column*/ } = e;

                    if(row !== undefined) {
                        let dados_mapa_aux =JSON.parse(JSON.stringify(dados_mapa_primary.current))
                        dados_mapa_aux[row]['highlight'] = true
                        set_dados(dados_mapa.current = dados_mapa_aux)
                        // console.log('-->', dados_mapa_aux)
                    }

                    // console.warn("MOUSE OVER ", { row, column });
                });
                //   google.visualization.events.addListener(chart, "onmouseout", e => {
                //     const { row, column } = e;
                //     console.warn("MOUSE OUT ", { row, column });
                //   });
            }
        },
        {
            eventName: "select",
            callback({ chartWrapper }) {
                console.log("Selected ", chartWrapper.getChart().getSelection());
            }
        }
    ]

    return (isloading ?

		<Loader />
		
    :

        <>
            <Navbar />
            <Breadcrumb />
            <main className="article">
                {
                content.composicao.map((el, k) => {  
                    return (
                        <section key={k} className="content-body">
                            <div className="container my-5">
                                <div className="row">
                                    <div className='col-12 text-right'>
                                        <a className="btn btn-text" href={'./routes/all'} >
                                            <i className="bi bi-chevron-left pr-1"></i>{language[lang].back}
                                        </a>
                                    </div>
                                    <div className="div-content col-12 mt-5">
                                        <div className="row">
                                            <div className='col-12 col-sm-8'>
                                                <div className={"div-title"}>
                                                    <h1 className="titulo-primario">{translate(el.descricao.nome, lang)}</h1>
                                                </div>

                                                <div className={"div-image mt-3"}>
                                                    {
                                                    el['media'] !== undefined && el['media']['image'] !== undefined && el['media']['image'].length > 0 ?
                                                        <div className="accommodation-img"> 
                                                            <AssecImage 
                                                                linkImage={el['media']['image'][0]['link']}
                                                                width="400"
                                                                height="300"
                                                                fit='crop'
                                                                type='img'
                                                                sClass="img-fluid rounded mb-2" 
                                                                alt={el['media']['image'][0]['name']}
                                                            />
                                                            {/*<img src={el['media']['image'][0]['link']} className="img-fluid" alt={el['media']['image'][0]['name']} />*/}
                                                        </div>
                                                    :
                                                        null
                                                    }
                                                </div>

                                                <div className={"div-abstract mt-5"}>
                                                    {ReactHtmlParser(translate(el.descricao.descricao, lang))}
                                                </div>
                                                
                                                <div className={"div-text mt-5"}>
                                                    {ReactHtmlParser(el.text)}
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-4'>

                                                <h4 className="bg-primary rounded-lg text-white w-100 py-2 text-center">Informação</h4>

                                                <p>
                                                    <strong>Extensão:</strong> {el.distancia}
                                                    <br />
                                                    <strong>Dificuldade:</strong> {translate(el.dificuldade, lang)}
                                                    <br />
                                                    <strong>Tipo:</strong> {translate(el.tipo, lang)}
                                                </p>

                                                <div className='bg-light text-center p-3 mb-3 d-none'>
                                                    <p>Descarregar trilho</p>
                                                    {
                                                    el['multimedia'] !== undefined && el['multimedia']['link_docs'][0] !== undefined && el['multimedia']['link_docs'][0].length > 0 ? 
                                                        el['multimedia']['link_docs'][0].map((el_f, k_f) => {
                                                            return (
                                                                el_f.tipo === 'trilho' ?
                                                                    <a key={k_f} className='btn btn-primary mb-2 mr-2' href={el_f.link}> {translate(el_f.nome, lang)} </a>
                                                                
                                                                :
                                                                    null
                                                            )
                                                        })
                                                    :
                                                        null
                                                    }
                                                </div>

                                                <div className='bg-light text-center p-3 mb-3'>
                                                    <p>Folheto e Mapa PDF</p>
                                                    {
                                                    el['multimedia'] !== undefined && el['multimedia']['link_docs'][0] !== undefined && el['multimedia']['link_docs'][0].length > 0 ? 
                                                        el['multimedia']['link_docs'][0].map((el_f, k_f) => {
                                                            return (
                                                                el_f.tipo === 'mapa' ?
                                                                    <a key={k_f} className='btn btn-primary mb-2 mr-2' href={el_f.link}> {translate(el_f.nome, lang)} </a>
                                                                
                                                                :
                                                                    null
                                                            )
                                                        })
                                                    :
                                                        null
                                                    }
                                                </div>

                                                <div className='bg-light text-center p-3 mb-5'>
                                                    <p>Ficha Técnica</p>
                                                    {
                                                    el['multimedia'] !== undefined && el['multimedia']['link_docs'][0] !== undefined && el['multimedia']['link_docs'][0].length > 0 ? 
                                                        el['multimedia']['link_docs'][0].map((el_f, k_f) => {
                                                            return (
                                                                el_f.tipo === 'ficha' ?
                                                                    <a key={k_f} className='btn btn-primary mb-2 mr-2' href={el_f.link}> {translate(el_f.nome, lang)} </a>
                                                                
                                                                :
                                                                    null
                                                            )
                                                        })
                                                    :
                                                        null
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {
                                    el['multimedia'] !== undefined && el['multimedia']['link_docs'][0] !== undefined && el['multimedia']['link_docs'][0].length > 0 ? 
                                        <div className="div-content col-12 mb-5">
                                            <div className="row div-documents">
                                                {
                                                el['multimedia']['link_docs'][0].map((el_f, k_f) => {
                                                    return (
                                                        el_f.tipo === 'doc' ?
                                                            <a key={k_f} className='btn btn-primary mb-2 mr-2' href={el_f.link}> {translate(el_f.nome, lang)} </a>
                                                        
                                                        :
                                                            null
                                                    )
                                                })
                                                }
                                            </div>
                                        </div>
                                    :
                                        <></>
                                    }
                                    {
                                    el['multimedia'] !== undefined && el['multimedia']['link_images'] !== undefined && el['multimedia']['link_images'][0] !== undefined && el.multimedia.link_images[0].length > 1 ?
                                        <div className="div-content col-12 mb-5">
                                            <div className="row div-gallery">
                                                {
                                                el.multimedia.link_images[0].map((el_img, k_img) => {
                                                    if(k_img > 0) {
                                                        return (
                                                            <div key={k_img} className="col-6 col-sm-3 col-lg-2 p-0">
                                                                <a
                                                                    href={el_img.link}
                                                                    data-fancybox="gallery"
                                                                    data-caption={(el_img.link.includes(translate(el_img.nome, lang)) || translate(el_img.nome, lang).includes('webp') || translate(el_img.nome, lang).includes('jpg') || translate(el_img.nome, lang).includes('png')) ? '' : translate(el_img.nome, lang)}
                                                                >
                                                                    <AssecImage
                                                                        linkImage={el_img.link !== undefined ? el_img.link : repo_img_link('nophoto.png')}
                                                                        width="400"
                                                                        height="400"
                                                                        fit='crop'
                                                                        type='img'
                                                                        sClass='img-fluid'
                                                                        alt={(el_img.link.includes(translate(el_img.nome, lang)) || translate(el_img.nome, lang).includes('webp') || translate(el_img.nome, lang).includes('jpg') || translate(el_img.nome, lang).includes('png')) ? '' : translate(el_img.nome, lang)}
                                                                        title={(el_img.link.includes(translate(el_img.nome, lang)) || translate(el_img.nome, lang).includes('webp') || translate(el_img.nome, lang).includes('jpg') || translate(el_img.nome, lang).includes('png')) ? '' : translate(el_img.nome, lang)}
                                                                    />
                                                                </a>
                                                            </div>
                                                        )
                                                    }
                                                    else
                                                        return null
                                                })
                                                }
                                            </div>
                                        </div>
                                    :
                                        <></>
                                    }
                                </div>
                            </div>
                            
                            {
                            false ?
                                <div style={{ height: '800px', width: '100%' }}>
                                    <GoogleMapReact
                                        bootstrapURLKeys={{ key: "AIzaSyCZB3DS4HSEdzCRKvhscjp_QzW4o9buga4" }}
                                        defaultCenter={dados_mapa_settings.current.center}
                                        defaultZoom={dados_mapa_settings.current.zoom}
                                    >
                                        {
                                        dados_mapa.current.map((el, k) => {
                                            if(k === 0) {
                                                return (
                                                    <AnyReactComponent
                                                        key={k}
                                                        lat={el.coordenadas.latitude}
                                                        lng={el.coordenadas.longitude}
                                                        text="#"
                                                        icon='flag-fill'
                                                    />
                                                )

                                            }
                                            else {
                                                return (
                                                    <AnyReactComponent
                                                        key={k}
                                                        lat={el.coordenadas.latitude}
                                                        lng={el.coordenadas.longitude}
                                                        text="."
                                                        icon='circle-fill'
                                                    />
                                                )
                                            }
                                        })
                                        }
                                    </GoogleMapReact>
                                </div>
                            :
                                null
                            }

                            <div className="container">
                                <div className="row">
                                    <div className="col-12 p-0 my-5" style={{ height: '400px', width: '100%' }}>
                                        {
                                        false ?
                                            <Chart 
                                                data={dados_chart.current} 
                                                axes={axes_chart} 
                                                onMouseEnter={(e) => hover_chart(e)}
                                                onMouseLeave={(e) => hover_chart(e)}
                                                tooltip
                                            />
                                        :
                                            null
                                        }

                                        <Chart
                                            chartType="Line"
                                            // data={[["Age", "Weight"], [4, 5.5], [8, 12]]}
                                            data={dados_chart_2.current}
                                            width="100%"
                                            height="400px"
                                            legendToggle
                                            chartEvents={chartEvents}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 p-0">
                                    {
                                    !loadMap ? 
                                        <div className="d-flex justify-content-center">
                                            <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    : 
                                        <GMap dados_coordenadas={dados_mapa.current} 
                                    />}
                                    </div>
                                </div>
                            </div>

                        </section>
                    )
                })
                }
            </main>
            <Footer />
        </>
    )
}